import { TromanError } from '../../common/TromanError';
import { RESPONSE_404, RESPONSE_502 } from '../../common/ApiResponseCodes';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class IntegrationEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this.url = url;
        this._api = api;
    }

    lookupPerson(personalNumber) {
        var dst = this.url + '/persons/lookup';
        return this._api.postResponse(dst,
            {
                personalNumber: personalNumber
            })
            .then(rsp => rsp.getResult())
            .catch((error) => {
                if (error instanceof TromanError) {
                    if (error.code === RESPONSE_404) {
                        return null;
                    }
                    if (error.code === RESPONSE_502) {
                        throw error.message;
                    }
                }

                throw error;
            });
    }
}

